import React, { Component } from 'react'
import PropTypes from 'prop-types'

class SelectGroupComponent extends Component {
  constructor () {
    super()

    this.state = {
      value: 0
    }

    this.handleChange = this.handleChange.bind(this)
  }

  getChildContext () {
    const {name, selectedValue, onChange} = this.props
    return {
      selectGroup: {
        name, selectedValue, onChange
      }
    }
  }

  handleChange (event) {
    event.preventDefault()
    this.setState({value: parseInt(event.target.value, 10)}, () => {
      this.props.onChange(this.state.value, this.props.name)
    })
  }

  componentWillMount () {
    this.setState({value: parseInt(this.props.selectedValue, 10) || 0})
  }

  render () {
    const {Component, name, selectedValue, onChange, children, ...rest} = this.props
    return (
      <Component className='form__input__select demande-form__select' {...rest}>
        <span className='arr' />
        <select name={name} value={this.state.value} onChange={this.handleChange}>
          {children}
        </select>
      </Component>
    )
  }
}

const { string, number, bool, func, oneOfType, node, object } = PropTypes
SelectGroupComponent.propTypes = {
  name: string,
  selectedValue: oneOfType([
    string,
    number,
    bool
  ]),
  onChange: func,
  children: node.isRequired,
  Component: oneOfType([
    string,
    func,
    object
  ])
}

SelectGroupComponent.defaultProps = {
  Component: 'div'
}

SelectGroupComponent.childContextTypes = {
  selectGroup: PropTypes.object
}

export const SelectNumberGroup = SelectGroupComponent



// WEBPACK FOOTER //
// ./src/components/ui/inputs/SelectNumberGroup.js